import ModalContainer from "#/shared/components/ModalContainer"
import { useDepositMigrationModal } from "#/shared/hooks/deposit-migration"
import { MezoModalProps } from "#/shared/types"

import DepositMigrationModalBase from "./DepositMigrationModalBase"
import DepositMigrationSuccessModal from "./DepositMigrationSuccessModal"

export default function DepositMigrationModal({
  isOpen,
  onClose,
}: MezoModalProps) {
  const {
    deposits,
    currentlySelectedDeposit,
    onDepositCarouselChange,
    displaySuccessModal,
    onSuccessfulMigration,
    closeModal,
  } = useDepositMigrationModal(isOpen, onClose)

  return (
    <ModalContainer isOpen={isOpen} onClose={closeModal} width="522px">
      {displaySuccessModal ? (
        <DepositMigrationSuccessModal onClose={closeModal} />
      ) : (
        <DepositMigrationModalBase
          deposits={deposits}
          selectedDeposit={currentlySelectedDeposit}
          onDepositCarouselChange={onDepositCarouselChange}
          onSuccessfulMigration={onSuccessfulMigration}
        />
      )}
    </ModalContainer>
  )
}
